import { Grid2, Typography, useTheme } from "@mui/material";
import { getDate, isToday } from "date-fns";

type Props = {
    day: Date;
};

export default function DateSection({ day }: Props) {
    const isCurrentDay = isToday(day);
    const theme = useTheme();

    return (
        <Grid2 size={1} height={1} p={1}>
            <Typography
                variant="h5"
                sx={{
                    backgroundColor: isCurrentDay ? theme.palette.primary.main : "transparent",
                    color: isCurrentDay ? theme.palette.primary.contrastText : "inherit",
                    borderRadius: isCurrentDay ? "50%" : 0,
                    width: isCurrentDay ? 32 : "auto",
                    height: isCurrentDay ? 32 : "auto",
                    m: isCurrentDay ? "auto" : undefined,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {getDate(day)}
            </Typography>
        </Grid2>
    );
}
